import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-client-destination-maye-preview',
  templateUrl: './client-destination-maye-preview.component.html',
  styleUrls: ['./client-destination-maye-preview.component.scss']
})
export class ClientDestinationMayePreviewComponent {
  @Input() data: any = null;
  tab = 0;
}
